import Modal from '@components/common/modal';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useProfileDetail } from '@repository/profiles/useProfile';
import PreviewProfile from './previewProfile';
import AdditionInfo from './additionInfo';
import { useAdditionalInputContext } from '../additionalInputModal/AdditionalInputContext';

import classnames from 'classnames/bind';
import styles from './previewProfileModal.module.scss';
const cx = classnames.bind(styles);

interface PreviewProfileModalProps {
  visible: boolean;
  onClose: () => void;
}

const PreviewProfileModal = ({ onClose, visible }: PreviewProfileModalProps) => {
  const { data: userInfo } = useUserInfo();
  const { data: profileDetail } = useProfileDetail(!!userInfo?.id);
  const { previewData } = useAdditionalInputContext();

  if (!profileDetail) return null;

  return (
    <Modal visible={visible}>
      <div className={cx('previewProfile')} onClick={onClose}>
        <div className={cx('layer')}>
          <div className={cx('previewProfileArea')} onClick={(e) => e.stopPropagation()}>
            {/* 프로필 정보 */}
            <PreviewProfile {...profileDetail} onClose={onClose} />

            {/* 추가 정보 */}
            <AdditionInfo additions={previewData} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewProfileModal;
